import { render } from "./home.vue?vue&type=template&id=557f496f&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"

import "./home.vue?vue&type=style&index=0&id=557f496f&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-557f496f"

export default script